export const APP_VERSION = "1.2";
export const APP_BUILD_DATE = "2026-04-07";
